<template>
  <Modal v-model="model" sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide :mask="false" draggable scrollable class="insert_edit_pop" width="400">
    <div class="transfer_template">
      <div class="font_style_set"><span class="span_must">*</span>流程名称</div>
      <div class="transfer_input">
        <Input v-model="flowName" placeholder="请输入流程名称" title="流程名称"/>
      </div>
    </div>
    <div class="transfer_template">
      <div class="font_style_set"><span class="span_must">*</span>语音模型</div>
      <div class="transfer_input">
        <Select v-model="templateId" placeholder="请选择语音模型" title="语音模型">
          <Option v-for="(option,index) in templates" :value="option.id" :key="index">{{option.tName}}</Option>
        </Select>
      </div>
    </div>
    <div class="transfer_template">
      <div class="font_style_set">TTS声音</div>
      <div class="transfer_input">
        <Select v-model="ttsId" placeholder="请选择TTS声音" title="TTS声音" @on-change="changeTTS">
          <Option v-for="(option,index) in ttsVoices" :value="option.id" :key="index">{{option.descr}}</Option>
        </Select>
      </div>
    </div>
    <div class="transfer_template">
      <div class="font_style_set">流程简介</div>
      <div class="transfer_input">
        <Input v-model="flowDescr" placeholder="请输入流程简介" title="流程简介"/>
      </div>
    </div>
    <!--buttons-->
    <div class="btn_template" style="margin-top: 15px">
      <Button type="error" class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" :disabled="saveDisabled" @click="save()">保存</Button>
    </div>
  </Modal>
</template>

<script>
    import {publicFunClass} from "@/components/js/PublicFunClass";

    export default {
      name: "AIFlowEditPop",
      mixins: [publicFunClass],
      props: {
        showFlow:Boolean,
        showTitle:String,
        flowId:String,
        templateList:Array,
        ttsVoices:Array,
      },
      data(){
        return {
          model:false,
          saveDisabled:false,
          title:'添加流程',
          companyId:localStorage.getItem("companyId"),
          flowName:'',
          templateName:'',
          templateId:'',
          flowDescr:'',
          id:'',
          templates:[],
          configInfo: JSON.parse(localStorage.getItem('configInfo')),
          ttsId:'',
          ttsName:'',
        }
      },
      methods:{
        cancel() {
          this.$emit('closeAIFlowEditPop',false)
        },
        changeTTS(value) {
          value += ''
          let that = this
          this.ttsVoices.forEach(tv=>{
            if (tv.id+'' === value) {
              that.ttsId = tv.id
              that.ttsName = tv.voiceName
            }
          })
        },
        save() {
          let that = this
          if (this.id) {
            //更新
            let param = {
              id:this.id,
              rtId:this.templateId,
              rwName:this.flowName,
              rwDescr:this.flowDescr,
              vId:this.ttsId,
              vName:this.ttsName,
              menuId:'a_2-2',
              journalType:'AI机器人管理=>AI流程管理=>编辑流程',
            };
            this.$http.post("/AI/WorkFlow/update",param).then(res=>{
              let response = res.data
              if (response.flag !== '666') {
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return
              }
              that.$Message.success('编辑成功！');
              that.$emit('closeAIFlowEditPop',false)
            })
          } else {
            let param = {
              rtId:this.templateId,
              rwName:this.flowName,
              rwDescr:this.flowDescr,
              menuId:'a_2-1',
              journalType:'AI机器人管理=>AI流程管理=>新建流程',
              vId:this.ttsId,
              vName:this.ttsName,
            };
            this.$http.post("/AI/WorkFlow/add",param).then(res=>{
              let response = res.data
              if (response.flag !== '666') {
                that.$Modal.info({
                  title: '提示',
                  content: res.data.msg
                })
                return
              }
              that.$Message.success('新建成功！');
              that.$emit('closeAIFlowEditPop',false)
            })
          }

        },
        initData(id) {
          let param = {id:id}
          let that = this
          this.$http.post('/AI/WorkFlow/queryById',param).then(res=>{
            let response = res.data
            if (response.flag !== '666') {
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return
            }
            this.flowName = response.obj.rwName
            this.templateId = response.obj.rtId
            this.templateName = response.obj.tName
            this.flowDescr = response.obj.rwDescr
            this.ttsId = response.obj.vId
            this.ttsName = response.obj.descr
          })
        }
      },
      watch:{
        showFlow:{
          deep:true,
          handler(val){
            this.title=this.showTitle
            this.model=this.showFlow
            this.id=this.flowId
            this.saveDisabled=false
            this.templates=this.templateList
            this.flowName=''
            this.flowDescr=''
            this.templateId=''
            this.ttsId = ''
            this.ttsName = ''
            if (this.flowId) {
              this.initData(this.id)
            }
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/aiManager/AIFlowEditPop.vue